import { createRoot } from 'react-dom/client'
import React from 'react'
import queryString from 'query-string'
import { camelizeKeys } from 'humps'
import { shim as shimGroupBy } from 'object.groupby'

import '~/assets/fonts/fonts.css'

shimGroupBy()

function parse(search: string) {
  return queryString.parse(search, { parseBooleans: true, parseNumbers: true })
}

async function maybeEnableMocking() {
  if (import.meta.env.VITE_MSW !== 'true') {
    return
  }

  const { worker } = await import('~/mocks/browser')
  return worker.start({
    onUnhandledRequest: 'bypass',
  })
}

;(async () => {
  await maybeEnableMocking()

  const propsElement = document.querySelector(`[data-react-class]`)!
  const componentName = propsElement.getAttribute('data-react-class')!
  const Component = (await import(`./${componentName}/index.tsx`))[componentName]
  const reactPropsAttr = propsElement.getAttribute('data-react-props')!
  const props = camelizeKeys({
    ...parse(window.location.search),
    ...JSON.parse(reactPropsAttr),
  })
  const domNode = document.getElementById('root')!
  const root = createRoot(domNode)

  root.render(
    <React.StrictMode>
      <Component {...props} />
    </React.StrictMode>,
  )
})()
